import { createBrowserHistory, History } from "history";

let _history: History;

export const history: History = _history;

export const createHistory = (baseUrl: string) => {
    _history = createBrowserHistory({ basename: baseUrl });
    return _history;
};

export const getHistory = () => _history;
